import * as url from "../url.helper";

import { post } from "../api.helper";

export const addInsuranceDetails = data => post(url.ADD_INSURANCE_DETAILS, data);

export const getInsuranceDetails = data => post(url.GET_INSURANCE_DETAILS, data);

export const editInsuranceDetails= data => post(url.EDIT_INSURANCE_DETAILS, data);

export const deleteInsuranceDetails= data => post(url.DELETE_INSURANCE_DETAILS, data);
